import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormikContext } from "formik";
function FooterPrestataire({ linkRoute, isSubmitting,linkName, nameButton,handleSubmit ,btnSecondary,actionSecondary ,plan,topBlur = true  }) {
const navigate=useNavigate()
const [disabled,setDisabled]=useState(false)
  return (
    <>
      
       <div className={`footer-presta ${topBlur ? "has-top-blur" : ""}`}>
        {/* <div className="mt-footer"> */}
        {/* <hr /> */}
        <div className="container py-28">
        <div className="row align-items-center">
          <div className="col-md-6 col-sm-6 d-flex justify-content-start align-items-center">
            {linkName && (
              <>
                <img src="/images/icon-back.svg" alt="back-img"  />
                <button 
                  onClick={() => navigate(linkRoute, { state: { plan: plan } })}
                  className="link-blue text-decoration-none ml-8"
                  style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                >
                  {linkName}
                </button>
              </>
            )}
          </div>

          <div className="col-md-6 col-sm-6 d-flex justify-content-end">
          {btnSecondary && (
              <button
                type=""
                onClick={actionSecondary}
                className="twyny-cta-secondary mr-8"
              >
                {btnSecondary}
              </button>
            )}
            {nameButton && (
              <button
                type="submit"
                onClick={()=>{
                  setDisabled(true)
                  handleSubmit()
                }}
                className="twyny-cta-primary"
                disabled={isSubmitting}
              >
                {nameButton}
              </button>
            )}
          </div>
        </div>
        </div>
      </div>
    </>
  );
}

export default FooterPrestataire;
